import { Box, Grid, Button, Badge, Card, Typography, Paper, TableCell, Link } from '@mui/material';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { styled, alpha } from '@mui/material/styles';
// components/GeneralInfo/styled.js

import { } from '@mui/material';

// General Container Styles
export const Container = styled('div')`
  min-height: 100vh;
`;

// Styled Components for Calendar
export const StyledBadge = styled(Badge)(({ theme }) => ({
  '.MuiBadge-dot': {
    backgroundColor: 'transparent', // Remove the default dot if needed
  },
  '.MuiBadge-badge': {
    top: 5, // Adjust vertical positioning
    right: 8, // Adjust horizontal positioning
    backgroundColor: 'transparent', // Badge background color
    color: theme.palette.secondary.main, // Badge text color
    fontSize: '0.86rem', // Font size for price
    height: '1.5rem', // Adjust badge height
    width: '1.5rem', // Adjust badge width
    borderRadius: '50%', // Make badge circular
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
}));

export const StyledPickersDay = styled(PickersDay)(() => ({
  fontSize: '1.25rem', // Increase font size for days
}));

// Layout and Content Styles
export const SecondRowContainer = styled(Box)({
  maxWidth: '80vw', // Default width for desktop
  margin: '0 auto', // Center the container on desktop
  '@media (max-width: 900px)': {
    maxWidth: '100%', // Set width to 100% for smaller screens
  },
});

export const ContentWrapper = styled(Box)(({ theme }) => ({
  maxWidth: 1200,
  margin: '0 auto',
  padding: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(4),
  },
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: theme.shadows[2],
}));

export const ImageContainer = styled(Box)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  marginBottom: theme.spacing(3),
}));

export const ModalContent = styled('div')`
  background-color: transparent;
  max-height: 92vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0;
  width: auto;
  pointer-events: none; // Don't intercept clicks outside content
  
  & > * {
    pointer-events: auto; // Re-enable pointer events for children
  }
  
  @media (max-width: 768px) {
    max-height: 80vh;
    width: 90%; // Adjust for mobile
  }
`;

export const PromoContent = styled('div')`
  background-color: transparent;
  max-height: 92vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0;
  width: 65%; // Desktop width
  pointer-events: none;
  
  & > * {
    pointer-events: auto;
  }
  
  @media (max-width: 768px) {
    max-height: 80vh;
    width: 90%; // Mobile width
  }
`;


export const OverviewCenter = styled('div')`
  @media (max-width: 768px) {    
    margin: 0 5vw; // Center horizontally
  }
`;

export const OverviewLeft = styled('div')`
  @media (max-width: 768px) {    
    margin: 0 5vw; // Center horizontally
  }
`;

export const OverviewRight = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 10px;
  align-items: initial !important;

  @media (max-width: 768px) {    
    margin: 0 5vw; // Center horizontally
  }
`;


export const OverviewTitle = styled('div')(({ theme }) => ({
  fontSize: '1.2rem',
  fontWeight: 600,
  marginBottom: '15px',
  marginTop: '40px',
  marginLeft: '0px',
  color: theme.palette.secondary.main, // Badge text color
  backgroundColor: theme.palette.box_title.main, // Badge text color

}));

export const OfferContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: flex-start; // Corrected from 'top' to 'flex-start'
  align-items: flex-start; // Corrected from 'top' to 'flex-start'
  background-color: #fff;
  margin-bottom: 20px;
`;

export const LocationContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: flex-start; // Corrected from 'top' to 'flex-start'
  align-items: flex-start; // Corrected from 'top' to 'flex-start'
  background-color: #fff;
  margin-bottom: 20px;
`;

export const OpeningTimesContainer = styled('div')`
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 0.8rem;
`;

export const InfoTextSmall = styled('div')`
    align-items: start;
    font-size: 14px;
`

export const InfoTextMedium = styled('div')`
    font-size: 16px;
`

export const HeroBoxMain = styled('div')`
    width: 100%;    
    justify-content: center;
    align-items: center;
    flex-direction: row;
    display: flex;
    border-radius: 5px;
    border: 1px solid #e0e0e0;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
`

export const HeroAvatarContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 150px;
  margin: 5px;
`;

export const AvatarWrapper = styled('div')`
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
`;

export const HeroPriceContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 25%;
  font-size: 20px;
  font-weight: 700;
`;

export const HeroMainData = styled('div')`
    width: 100%;
    display: flex;
    flex-direction: column;
`

export const HeroMainText = styled('div')`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 5px;
    height: 100%;
`


export const ResponsiveTextField = styled('div')`
  width: 100%; /* Full width on mobile by default */

  @media (min-width: 600px) {
    width: 20%; /* 20% width on tablets and above */
  }
`;



export const VenueContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  maxWidth: '1400px',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0), // Remove padding on mobile
  }
}));

export const VenueHeader = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  '& h1': {
    fontSize: '2.5rem',
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
  },
  '& h2': {
    fontSize: '1.1rem',
    color: theme.palette.text.secondary,
  }
}));

export const ContentSection = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: theme.shape.borderRadius,
  boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
}));

export const AmenitiesGrid = styled(Grid)(({ theme }) => ({
  '& .amenity-item': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.05),
    }
  }
}));


export const BookingButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1.5, 4),
  borderRadius: '50px',
  fontSize: '1.1rem',
  fontWeight: 600,
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  transition: 'transform 0.2s',
  '&:hover': {
    transform: 'translateY(-2px)',
  }
}));


export const ContentCard = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: theme.shape.borderRadius,
  boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1.5, 4),
  borderRadius: '50px',
  fontWeight: 600,
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  transition: 'transform 0.2s',
  '&:hover': {
    transform: 'translateY(-2px)',
  }
}));

export const AmenityItem = styled(Grid)(({ theme }) => ({
  transition: 'background-color 0.2s',
  borderRadius: theme.shape.borderRadius,
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.05),
  }
}));


/////////////////////////
// New styles
/////////////////////////


export const OverviewMainTitle = styled('div')(({ theme }) => ({
  fontSize: '2.2rem',
  fontWeight: 600,
  color: theme.palette.section_title.main,
  marginTop: '0px',
  marginBottom: theme.spacing(0),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(2), // Add consistent margin on mobile
    fontSize: '1.4rem',
  }
}));

export const OverviewMainSubtitle = styled('div')(({ theme }) => ({
  fontSize: '0.9rem',
  fontWeight: 400,
  color: theme.palette.section_title.main, // Badge text color  
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    margin: '0 5vw', // Center horizontally
    textAlign: 'center',
    marginBottom: '5px',
    fontSize: '1rem',
  }
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: theme.shape.borderRadius,
  boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
  padding: theme.spacing(3),
  height: 'auto',
  '.image-gallery': {
    width: '100%',
    '.image-gallery-slide img': {
      borderRadius: theme.shape.borderRadius,
      height: '300px',
      objectFit: 'cover',
    }
  },
  [theme.breakpoints.down('md')]: {
    padding: 0, // Remove padding on mobile
    boxShadow: 'none', // Remove shadow on mobile
    borderRadius: 0, // Remove border radius on mobile
    '.image-gallery-slide img': {
      borderRadius: 0, // Remove border radius from images on mobile
    }
  }
}));

export const MainContentContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    '& > .MuiGrid-item': {
      display: 'flex',
      flexDirection: 'column',
      '&:first-of-type': {
        flexGrow: 1
      }
    }
  }
}));


// Styles for general Info



export const InfoContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2), // Reduce padding on mobile
    borderRadius: 0, // Remove border radius on mobile
    boxShadow: 'none', // Remove shadow on mobile
    '& .MuiGrid-container': {
      margin: 0, // Remove grid margins on mobile
    }
  }
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  fontWeight: 600,
  marginBottom: theme.spacing(2),
  color: theme.palette.secondary.main,
  marginTop: 0,  // Remove top margin since it's the first element
  height: '1.5em',  // Ensure consistent height for titles
  display: 'flex',
  alignItems: 'center'
}));

export const ContentText = styled(Typography)(({ theme }) => ({
  fontSize: '0.95rem',
  lineHeight: 1.6,
  color: theme.palette.text.secondary
}));

export const InfoBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(2),
  '& svg': {
    color: theme.palette.secondary.main
  }
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(1),
  fontSize: '0.95rem',
  color: theme.palette.text.secondary,
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  '&:first-of-type': {
    fontWeight: 500
  }
}));

export const ColumnContainer = styled(Grid)(() => ({
  minHeight: '100%',
  display: 'flex',
  flexDirection: 'column'
}));

export const LeftColumnContent = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  '& > div': {  // For the inner Box
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  }
}));

export const MapContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  marginTop: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  minHeight: '300px'  // Add minimum height to ensure map visibility
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline'
  }
}));

export const StickyContainer = styled(Box)(({ theme }) => ({
  position: 'sticky',
  top: 'calc(var(--navbar-height, 80px) + 5px)',
  [theme.breakpoints.down('md')]: {
    position: 'static'
  }
}));


// Gallery grid

// GalleryGrid/styled.js

export const GalleryContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'grid',
  gridTemplateColumns: '6fr 4fr',
  gap: '8px',
  height: '300px',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    height: '250px',
    gridTemplateColumns: '1fr',
    gap: 0,
    '& .image-gallery': {
      margin: 0,
      width: '100vw',
      position: 'relative',
      left: '50%',
      right: '50%',
      marginLeft: '-50vw',
      marginRight: '-50vw',
    }
  }
}));

export const MainImage = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: '300px', // Match container height
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: `${theme.shape.borderRadius}px 0 0 ${theme.shape.borderRadius}px`,
    cursor: 'pointer'
  },
  [theme.breakpoints.down('md')]: {
    height: '250px',
    '& img': {
      borderRadius: theme.shape.borderRadius
    }
  }
}));

export const SmallImagesContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gridTemplateRows: '1fr 1fr',
  gap: '8px',
  height: '300px', // Match container height
  [theme.breakpoints.down('md')]: {
    display: 'none'
  }
}));

export const SmallImage = styled(Box)(({ theme }) => ({
  height: '146px', // Half of container height minus gap
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    cursor: 'pointer'
  },
  '&:nth-of-type(2) img': {
    borderRadius: `0 ${theme.shape.borderRadius}px 0 0`
  },
  '&:nth-of-type(4) img': {
    borderRadius: `0 0 ${theme.shape.borderRadius}px 0`
  }
}));

export const GridContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    margin: 0,
    width: '100%',
    '& > .MuiGrid-item': {
      padding: theme.spacing(1, 0), // Remove horizontal padding, keep vertical
    }
  }
}));

export const DescriptionTypography = styled(Typography)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.down('md')]: {
    paddingLeft: 0,
    paddingRight: 0,
  }
}));